import React from 'react'
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
const ShippingPolicy = () => {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="max-w-4xl mx-auto p-4 py-10 md:py-20 text-justify">
    {/* <h1 className="text-2xl font-bold mb-4 text-center  py-10">Shipping Policy</h1> */}
    <h1 className=" font-bold mb-4">Shipping Policy</h1>
    <p className="mb-4">
      At carizo.in, we provide world-class shipping to all our customers that includes inspection, fast & on-time delivery, top-quality packaging, and timely communication at each stage of shipping.
    </p>
    <p className="mb-4">
      We completely understand that once you buy merchandise online, the biggest question usually is "Where is my stuff?" - well, with us, we address that worry. This means that once you have bought a product at our site, we take care of everything so you don't have to be anxious about anything.
    </p>
    <p className="mb-4">
      We have partnered with most of the top courier and logistics partners to assure that you receive your order on time and safely with full courtesy and attention.
    </p>
    <p className="mb-4 font-bold">Please Note:</p>
    <ul className="list-disc ml-8 mb-4">
      <li>
        Shipping Charges are dependent on the product. The shipping charges may be waived off if you shop for a minimum predefined value or if the same is in promotion or on a product-to-product case. Shipping charges, if any, for a product are indicated along with the product and you are informed about it before making the purchase.
      </li>
      <li>
        The delivery time frame mentioned on product details is estimated. Actual delivery time depends upon availability, address where the order needs to be delivered and courier issues and other circumstances that might affect delivery. You can rest assured that you are completely protected as a shopper at carizo.in. You always have a choice to cancel your order due to shipment delay by contacting us at Customer Support.
      </li>
      <li>
      At carizo.in, products sold by the sellers on our platform may attract shipping charges. The shipping charges are not fixed and depend on various factors like nature / category of your product, which location dispatched from, gross weight of the product, etc. This amount will be over and above the value of the product that you see on our website.
      </li>
      <li>
      The shipping charges on your order will be informed before your order is being placed at carizo.in. If you are placing your order through our call centre, the order taker will mention the shipping charges. If it's via web or mobile, the shipping charge would reflect on the shopping cart / payment page.
      </li>
      <li>
      We are not responsible for any delay caused by any unforeseen time lags by the courier companies in delivering the goods to the customer, or if the customer is not available at the time of delivery.
      </li>
      
        </ul>
        
        </div>
  )
}

export default ShippingPolicy